import HttpService from '../../../shared/services/HttpService';
import {LoginPayload, MeResponse, NewUser} from '../types';
import { LoginReponse, User } from '../types';
import axios from 'axios';

export default class AuthService {
    private http = new HttpService();

    public async login(data: LoginPayload): Promise<LoginReponse> {
        try {
            return await this.http.post('login', data);
        } catch (e) {
            throw e;
        }
    }

    public async fetchUser(username: string): Promise<LoginReponse> {
        try {
            return await this.http.get('users/' + username);
        } catch (e) {
            throw e;
        }
    }

    public async me(ref: string): Promise<MeResponse> {
        return await this.http.get('ap/users/' + ref);
    }

    public async register(data: NewUser): Promise<User> {
        return await this.http.post('user/register', data);
    }

    public async confirm(data: any): Promise<any> {
        return await this.http.post('user/confirm', data);
    }

    public async refreshToken(): Promise<any> {
        return await this.http.post('token/refresh', {
            refresh_token: localStorage.getItem('refresh_token'),
        });
    }
}
